import React, { Fragment, useEffect } from 'react'
import { Container, makeStyles, Grid, FormControl, Button, InputLabel, Select, MenuItem } from '@material-ui/core';
import { BackNav } from '../../components';
import { useTranslation } from 'react-i18next';
import { useSelector, useDispatch } from 'react-redux';
import { ideaStepFluxUpdateActions } from '../../actions';
import { Save } from '@material-ui/icons';
import { useParams } from 'react-router-dom';

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
    },
    labelRoot: {
        fontWeight: 600,
        lineHeight: 1,
    },
    input: {
        padding: '27px 12px 10px'
    },
    error: {
        color: theme.palette.auxiliary.red.main,
        marginLeft: 14,
        marginRight: 14,
        marginTop: 3,
        fontSize: '0.6428571428571428rem',
        fontWeight: 400,
        lineHeight: 1.66,
    },
    checkbox: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        marginLeft: -8,
        marginTop: 8,
    },
    checkboxText: {
        color: theme.palette.neutrals.low.dark,
        fontSize: 18,
        fontWeight: 600,
    },
    stateContainer: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        margin: theme.spacing(5, 0, 2)
    },
    stateTitle: {
        color: theme.palette.neutrals.low.dark,
        fontSize: 18,
        fontFamily: 'Poppins',
        fontWeight: 600,
        marginRight: 16,
    },
    state: {
        fontSize: 14.22,
        color: theme.palette.neutrals.low.main,
        marginLeft: 8,
    },
    content: {
        padding: theme.spacing(2),
        [theme.breakpoints.up('sm')]: {
            padding: theme.spacing(2, 4)
        }
    },
    marginTopHigh: {
        marginTop: 20
    }
}));

function IdeaStepFluxEditAssociationsPage() {
    const dispatch = useDispatch();
    const ideaStepFluxUpdate = useSelector((state) => state.ideaStepFluxUpdate);
    const { ideasStepsFlux } = useSelector((state) => state.domains);
    const classes = useStyles();
    const { t } = useTranslation();
    const { id: _id } = useParams();

    const SelectProps = {
        anchorOrigin: {
          vertical: 'bottom',
          horizontal: 'left',
        },
        transformOrigin: {
          vertical: 'top',
          horizontal: 'left',
        },
        getContentAnchorEl: null,
      };

    useEffect(() => {
        dispatch(ideaStepFluxUpdateActions.setNewContent({ name: '_id', value: _id }));
    }, [dispatch]);


    function handleSend() {
        dispatch(ideaStepFluxUpdateActions.editIdeaStepFlux(ideaStepFluxUpdate))
    }

    function onChangeSelected(event, itemName) {
        dispatch(ideaStepFluxUpdateActions.setNewContent({ name: itemName, value: event.target.value }));
    }

    return (
        <Container maxWidth="lg" className={classes.root}>
            <BackNav title={t('editar_fluxo_associacao')} pathname="/preferences/flux-of-ideas" />
            <Container style={{ marginTop: 32 }}>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <FormControl fullWidth variant="filled">
                        <InputLabel>Selecione a próxima etapa se aprovada</InputLabel>
                          <Select
                            MenuProps={SelectProps}
                            defaultValue={ideaStepFluxUpdate?.nextStepWhenApproved}
                            onChange={(e) => onChangeSelected(e, 'nextStepWhenApproved')}
                          >
                          {ideasStepsFlux.map((value, index) => (
                            <MenuItem value={value._id} key={index}> {value.name}</MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </Grid>
                    <Grid item xs={12}>
                        <FormControl fullWidth variant="filled">
                            <InputLabel>Selecione a próxima etapa se reprovada</InputLabel>
                            <Select
                                MenuProps={SelectProps}
                                defaultValue={ideaStepFluxUpdate?.nextStepWhenRejected}
                                onChange={(e) => onChangeSelected(e, 'nextStepWhenRejected')}
                            >
                            {ideasStepsFlux.map((value, index) => (
                                <MenuItem value={value._id} key={index}> {value.name}</MenuItem>
                            ))}
                        </Select>
                      </FormControl>
                    </Grid>
                    <Grid item xs={3}>
                        <Button
                            variant="contained"
                            color="primary"
                            startIcon={<Save />}
                            onClick={() => handleSend()}
                            disabled={ideaStepFluxUpdate?.loading}
                        >
                            {t('salvar_associacoes_fluxo')}
                        </Button>
                    </Grid>
                </Grid>
            </Container>
        </Container>
    );
}

export { IdeaStepFluxEditAssociationsPage };